import { Container } from "@mui/material";
import React from "react";
import DesktopMenu from "./component/DesktopMenu";
import MobileMenu from "./component/MobileMenu";
import Medium from "../../../assets/images/medium.png"
import Twitter from "../../../assets/images/twitter.png"
import Telegram from "../../../assets/images/telegram.png"

const LockerMenu = (props) => {
  const menuList = [
    // You can pass 4 perameters for menu title, link, target and customClass

    {
      title: "Home",
      link: "/#home",
    },
    {
      title: "Features",
      link: "#features",
    },
    {
      title: "$ARB Reflection",
      link: "#arbreflection",
    },
    {
      title: "Tokenomics",
      link: "#tokenomics",
    },
    {
      title: "ETH to Arbitrum Bridge",
      link: "/#",
      target: "blank"
    },
    {
      title: "|",
    },
    {
      title: <img src={Medium} />,
      link: "https://arbflow.medium.com/",
      target: "blank",
    },
    {
      title: <img src={Twitter} />,
      link: "https://twitter.com/arbflowfinance",
      target: "blank",
    },
    {
      title: <img src={Telegram} />,
      link: "https://t.me/arbflowfinance",
      target: "blank",
    },
  ];
  return (
    <Container maxWidth="xl"
      data-aos="fade-zoom-in"
      data-aos-easing="ease-in"
      data-aos-delay="400"
      data-aos-duration="400"
      data-aos-offset="0">
      <DesktopMenu menuList={menuList} />
      <MobileMenu menuList={menuList} />
    </Container>
  );
};

export default LockerMenu;
